import { MessageFooter } from '@zg-rentals/satellite-components';

type PhoneLeadProps = {
  isMessageOwner: boolean;
  messageContent: string;
  messageDateMs: string;
};

export default function PhoneLead({ isMessageOwner, messageContent, messageDateMs }: PhoneLeadProps): JSX.Element {
  return (
    <>
      <audio controls={true}>
        <source src={messageContent} />
      </audio>

      <MessageFooter isMessageOwner={isMessageOwner} messageDateMs={messageDateMs} />
    </>
  );
}
